<template>
  <div>

    <z-loading :loading="store.loading" message="Carregando configurações...">
      <v-row>

        <v-col cols="3">
          <!-- <h3 class="text-body-2 font-weight-bold mb-2">Configurações</h3> -->
          <v-card flat outlined tile color="transparent">
            <v-card-text class="pa-0" color="transparent">
              
              <v-list dense  nav color="transparent">
                <v-list-item-group v-model="configuracaoSelecionada" mandatory>
                  
                  <template v-for="(config, index) in listaConfigracoes">

                    <v-list-item :value="config" color="primary" @click="" v-show="$auth.isAdmin() || !config.admin">
                      <v-list-item-icon class="mr-3">
                        <v-icon>{{ config.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="text-body-2">
                          {{ config.descricao }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    
                  </template>

                </v-list-item-group>

              </v-list>

            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="9">
          <v-scroll-y-reverse-transition mode="out-in">
            <component :is="configuracaoSelecionada.componente"></component>
          </v-scroll-y-reverse-transition>
        </v-col>

      </v-row>
    </z-loading>

  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useConfigStore } from '@/app/store/pinia/configuracoes'
import SistemaConfig from "./configs/SistemaConfig";
import TerminalImpressaoConfig from "./configs/TerminalImpressaoConfig";
import DashboardConfig from "./configs/DashboardConfig";
import CaixaConfig from "./configs/CaixaConfig.vue";
import AdminConfig from "./configs/AdminConfig.vue";

const store = useConfigStore();

const listaConfigracoes = ref([
  { descricao: 'Dashboard', icon: 'mdi-view-dashboard', componente: DashboardConfig, admin: true },
  { descricao: 'Terminal e Impressão', icon: 'mdi-printer', componente: TerminalImpressaoConfig, admin: false },
  { descricao: 'Financeiro', icon: 'mdi-currency-usd', componente: CaixaConfig, admin: false },
  { descricao: 'Sistema', icon: 'mdi-cog', componente: SistemaConfig, admin: false },
  { descricao: 'Admin', icon: 'mdi-lock', componente: AdminConfig, admin: true },
]);

const configuracaoSelecionada = ref({
  componente: DashboardConfig,
});

// const configuracoes = computed(() => {
//   return store.configuracoes;
// })

onMounted(async () => {
  // store.loading = true;
  await store.carregarConfiguracoes();
  await store.carregarListaConfiguracoes();
  await store.loadTerminalConfig();
  // store.loading = false;
});

// let timer = null;
// watch(configuracoes, (newValue) => {
//     clearTimeout(timer);
//     timer = setTimeout(() => {
//       // salvar(newValue);
//     }, 1500);
// },{ deep: true })

</script>

<style lang="scss" scoped>

</style>
